/* eslint-disable */ 
export default {
    props : {

            authorizeUrl: { type: String, default: "" },
            tokenUrl: { type: String, default: "" },
            logoutUrl: { type: String, default: "" },
            scope: { type: String, default: "" },
            autoLogin: { type: Boolean, default: true },
            client_id: { type: String, default: "" },
            client_secret: { type: String, default: "" },
            redirect_uri: { type: String, default: "" },
            showDebugInfo: { type: Boolean, default: false },

    },
    computed : {
        hasOauthResponse() {
            // // ;
            var querystring = this.$route.query;
            var keys = Object.keys(querystring);
            if (keys.indexOf("code") >= 0 && keys.indexOf("session_state") >= 0 && keys.indexOf("state") >= 0) {
                // ;
                return true;
            }
            return false;
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/auth/oauth-mixin.js